import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { useUserContext } from '../../providers/UserProvider';
import { EXTERNAL_PATHS } from '../../constants';
import UnreadIndicator from '../UnreadIndicator';
import NavItem from './NavItem';

const MAX_DISPLAYED_UNREAD_COUNT = 99;

type InboxNavItemProps = {
  classNameModifier?: string;
};

const InboxNavItem: FC<InboxNavItemProps> = ({ classNameModifier }) => {
  const [t] = useTranslation('navbar');
  const { user } = useUserContext();
  const unreadCount = user?.unread_messages_count ?? 0;
  const unreadCountLabel = unreadCount > MAX_DISPLAYED_UNREAD_COUNT
    ? `${MAX_DISPLAYED_UNREAD_COUNT}+`
    : String(unreadCount);

  return (
    <NavItem
      classNameModifier={classNameModifier}
      to={EXTERNAL_PATHS.INBOX}
      icon="envelope"
      indicator={unreadCount > 0 ? (
        <UnreadIndicator
          classNameModifier={classNames({ cappedCount: unreadCount > MAX_DISPLAYED_UNREAD_COUNT })}
          /*
          * UX: We always show an unread indicator when there are unread messages,
          * but only render a numeric badge when there is more than one unread.
          * Passing `undefined` for `unreadCount` intentionally signals to
          * `UnreadIndicator` to render a dot / generic badge without a number,
          * so a single unread message shows an unnumbered badge rather than "1".
          */
          unreadCountLabel={unreadCount > 1 ? unreadCountLabel : undefined}
        />
      ) : undefined}
    >
      {t('inbox')}
    </NavItem>
  );
};

export default InboxNavItem;
